// extracted by mini-css-extract-plugin
export default {"profitWidget":"hMUoK","clickable":"LVISj","content":"gixBX","clarification":"NRKaR","figures":"si6ey","block":"aft9K","icon":"ODdu3"};